/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://ffto3tjryrdj5l3gnuq3f3j3oq.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-2:42acb2c2-3711-43b1-b302-cede72248c78",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_utwcIjlDq",
    "aws_user_pools_web_client_id": "33k53diisknoqpnu68uocbin0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ObjectAudit-preview",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "alucio-beacon-content173401-preview",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
